<template>
  <ModalDialog
    class="chometz-attachments-modal"
    :header-text="headerText"
    @close-modal="closeModal"
    open
  >
    <template v-slot:content>
      <ChometzAttachmentsView
        class="chometz-attachments-view"
        :companyId="company.CompanyId"
        :plantId="company.PlantId"
        :saleYear="chometzSaleSeason"
        :allowDelete="false"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import type { ChometzCompany } from "@/Domain/ChometzCompany";
import ChometzAttachmentsView from "@/views/chometzSales/ChometzAttachmentsView.vue";
import { computed } from "vue";

const props = defineProps<{
  company: ChometzCompany;
  chometzSaleSeason?: number;
}>();

const emit = defineEmits(["closeModal"]);

const headerText = computed(
  () =>
    `${
      props.company.IsPlant
        ? props.company.PlantName
        : props.company.CompanyName
    } Attachments`
);

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.chometz-attachments-modal {
  .chometz-attachments-view {
    @include media-breakpoint-up(sm) {
      width: 500px;
    }

    @include media-breakpoint-up(lg) {
      width: 800px;
    }
  }
}
</style>
